import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, ViewChild, AfterViewInit } from '@angular/core';
import { Observable, Subject, forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { animate, style, transition, trigger } from "@angular/animations";
import { getDistanceFromLatLon} from 'src/app/utils/utils.common';
import { AgmMap } from '@agm/core';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/service/corporate-service/corporate-service';
import { DriversService } from 'src/app/service/drivers-service/drivers-service';
import { LevelOfServiceService } from 'src/app/service/level-of-service/level-of-service.service';
import { ServiceAreasService } from 'src/app/service/service-areas-service/service-areas.service';

@Component({
  selector: 'app-possibility-assign-modal',
  templateUrl: './possibility-assign-modal.component.html',
  styleUrls: ['./possibility-assign-modal.component.css'],
  animations: [
  trigger('openCloseAssignSlideOut', [

    transition(':enter', [
      style({
        opacity: 0,
        transform: 'translateX(100%) scale(0.98)'
      }),
      animate(
        '280ms cubic-bezier(0.4, 0.0, 0.2, 1)',
        style({
          opacity: 1,
          transform: 'translateX(0) scale(1)'
        })
      )
    ]),

    transition(':leave', [
      animate(
        '220ms cubic-bezier(0.4, 0.0, 1, 1)',
        style({
          opacity: 0,
          transform: 'translateX(100%) scale(0.98)'
        })
      )
    ])

  ])
]
})

export class PossibilityAssignModalComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @ViewChild("AgmMap", { static: true }) agmElement: AgmMap;
  @Input('trip') trip: any;
  @Output() onCloseModal = new EventEmitter<any>();

  agmMap;
  user;
  searchDriver;
  selectedDriver = null;
  googleSelectedDriver = null;
  nearbyDrivers = [];

  manifestList = [];
  origin = { lat: 0.00000, lng: 0.00000 };
  driverLoc = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  preCorporate;
  preLevelOfServices = {};
  preSpaceTypes: any = {};
  preServiceAreas = {};
  isAllowRoute = false;
  selectedMethod = true;
  isLoadingDrivers = false;

  spaceTypes;
  filteredDrivers;
  isCapacity = true;
  isShowCapacityToggle = false;
  todayDate = [];
  timeZone;

  constructor(
    private serviceArea: ServiceAreasService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private assigTripsService: AssigTripsService,
    private socketService: SocketService
  ) { }

  ngOnInit() {
    console.log(this.trip);
    this.getUser();

    if (this.trip) {
       console.log(this.trip);
      this.origin = {
        lat: this.trip.jobOriginLatitude,
        lng: this.trip.jobOriginLongitude
      };
      this.destination = {
        lat: this.trip.jobDestinationLatitude,
        lng: this.trip.jobDestinationLongitude
      };

    }

 this.socketService.addListener(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (!this.googleSelectedDriver) return;
        const driverIndex = this.nearbyDrivers.findIndex(driver => driver._id === this.googleSelectedDriver._id);
        if (data.success) {
          this.nearbyDrivers[driverIndex].googleETA = data.message;
        } else {
          this.nearbyDrivers[driverIndex].googleETA = null;
        }
      });

    this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypes(),
      this.getServiceAreas(),
    ];

    requests.push(this.getCorporateUserById());

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      async ([res1, res2, res3, res4]) => {
        if (res1) {
          this.preLevelOfServices = await res1.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res2) {
          this.spaceTypes = res2;
          this.preSpaceTypes = await res2.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res3) {
          this.preServiceAreas = await res3.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res4) {
          this.preCorporate = res4;
        }
        this.getNearbyDriver();
      },
      error => {
        sweetAlert('Error', error, 'warning', 'OK');
      }
    );

  }


  ngOnChanges(changes): void {
    if (changes.trip && changes.trip.currentValue) {
      this.trip = changes.trip.currentValue;
    }
  }

  ngAfterViewInit() {

  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).endOf('day').toISOString()
          ];
        }
      });
  }

  getNearbyDriver() {
    if (this.isLoadingDrivers) return;
    this.isLoadingDrivers = true;
    let data: any = {}

    let violation;

    data = {
      jobOriginLatitude: this.trip.jobOriginLatitude,
      jobOriginLongitude: this.trip.jobOriginLongitude,
      jobOriginAddress: this.trip.jobOriginAddress,
      fundingSource: this.trip.cooperate,
      spaceType: this.trip.spaceType,
      scheduleTime: this.trip.scheduleTime,
      isNearBy: true,
      loadTime: this.preSpaceTypes[this.trip.spaceType].loadTime || "0",
      unloadTime: this.preSpaceTypes[this.trip.spaceType].unloadTime || "0",
      milage: this.trip.milage,
      jobDestinationLatitude: this.trip.jobDestinationLatitude,
      jobDestinationLongitude: this.trip.jobDestinationLongitude,
      jobDestinationAddress: this.trip.jobDestinationAddress,
      appointmentTime: this.trip.appointmentTime,
    };

    if (this.trip.serviceArea) {
      data.serviceArea = this.trip.serviceArea
    }

    if (this.preCorporate && this.preCorporate.companyType) {
      data.companyType = this.preCorporate.companyType;
    }



    this.driverService
      .getNearbyDrivers(data)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.drivers) {
          this.nearbyDrivers = data.drivers;
          this.nearbyDrivers.sort((a, b) => {
            const milesA = (typeof a.miles === 'number' && !isNaN(a.miles)) ? a.miles : Infinity;
            const milesB = (typeof b.miles === 'number' && !isNaN(b.miles)) ? b.miles : Infinity;
            return milesA - milesB;
          });

          this.filterCapacityBaseTrips();
        }
        this.isLoadingDrivers = false;
      }, err => {
        this.isLoadingDrivers = false;
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  onSelectDriver(driver) {
    this.selectedDriver = driver;
    this.driverLoc = {
      lat: driver.coords[1],
      lng: driver.coords[0]
    };

    if (driver.assigns && driver.assigns.length) {
      this.manifestList = driver.assigns;
    } else {
      this.getManifestTrips();
    }
  }

  getManifestTrips() {
    const payload = {
      scheduleTime: this.trip.scheduleTime,
      driverId: this.selectedDriver._id
    };
    this.manifestList = [];
    this.assignTripService
      .fetchManifestTrips(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(async data => {
        if (data && data.assigns) {
          this.manifestList = data.assigns;
          const findTrip = this.manifestList.find(item => item._id === this.trip._id)
          if (!findTrip) {
            this.manifestList.push({ ...this.trip, isPurposeTrip: true });
          } else {
            findTrip.isPurposeTrip = true;
          }
          await this.manifestList.sort(
            (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
          );

          await this.checkPossibility();
        }
      });
  }


  async checkPossibility() {
    let lastTrip;

    if (this.selectedDriver && this.selectedDriver.startingPointAddress) {
      lastTrip = this.selectedDriver;
      lastTrip.coords[1] = this.selectedDriver.startingPointAddress.latitude;
      lastTrip.coords[0] = this.selectedDriver.startingPointAddress.longitude;
      lastTrip.isGarage = true;
    }

    if (this.selectedDriver && this.selectedDriver.coords && this.selectedDriver.coords.length) {
      lastTrip = this.selectedDriver;
    }

    for (let myTrip of this.manifestList) {

      if (!lastTrip) {
        lastTrip = myTrip;
        continue
      }
      await this.setNextTripPickupTime(lastTrip, myTrip);
      lastTrip = myTrip;
    }

  }
  async setNextTripPickupTime(lastTrip, currentTrip) {
    let puDistanceAndTime;
    if (lastTrip.coords && lastTrip.coords.length) {
      puDistanceAndTime = await this.calculateDistance(
        lastTrip.coords[1], lastTrip.coords[0],
        currentTrip.jobOriginLatitude, currentTrip.jobOriginLongitude);
    } else {
      puDistanceAndTime = await this.calculateDistance(
        lastTrip.jobDestinationLatitude, lastTrip.jobDestinationLongitude,
        currentTrip.jobOriginLatitude, currentTrip.jobOriginLongitude);
    }


    let minutesToAdd = 0;
    if (puDistanceAndTime) {
      if (currentTrip.tripRequirement === 'WAV') {
        minutesToAdd += 5;
      } else if (currentTrip.tripRequirement === 'Stretcher') {
        minutesToAdd += 15;
      } else {
        minutesToAdd += 2;
      }

      let approxPUCurrentTrip;
      if (lastTrip.coords && lastTrip.coords.length) {
        approxPUCurrentTrip = moment().tz(this.user.timeZone).add(puDistanceAndTime.duration * minutesToAdd, 'minutes');

      } else {
        const lastAptTimePredic = lastTrip.approxDO ? lastTrip.approxDO : lastTrip.appointmentTime;
        approxPUCurrentTrip = moment(lastTrip.appointmentTime).tz(this.user.timeZone).add(puDistanceAndTime.duration * minutesToAdd, 'minutes');
      }
      // to check late or on time
      let approxPUCurrentTripDiff = moment(currentTrip.scheduleTime).tz(this.user.timeZone).diff(approxPUCurrentTrip, 'minutes', true);


      // currentTrip.approxPU = {
      //   time: approxPUCurrentTrip.toISOString(),
      //   difference: approxPUCurrentTripDiff,
      //   pointsDistance: puDistanceAndTime
      // };
      currentTrip.approxPU = approxPUCurrentTrip.toISOString();
      // currentTrip.minutesToPickup = approxPUCurrentTripDiff;
      currentTrip.minutesToPickup = puDistanceAndTime.duration;
      currentTrip.puMiles = puDistanceAndTime.distance;

      const doDistanceAndTime = await this.calculateDistance(
        currentTrip.jobOriginLatitude, currentTrip.jobOriginLongitude,
        currentTrip.jobDestinationLatitude, currentTrip.jobDestinationLongitude);

      if (doDistanceAndTime) {

        let approxDOCurrentTrip = moment(currentTrip.approxPU).tz(this.user.timeZone).add(doDistanceAndTime.duration * minutesToAdd, 'minutes');
        // to check late or on time
        let approxDOCurrentTripDiff = moment(currentTrip.appointmentTime).tz(this.user.timeZone).diff(approxDOCurrentTrip, 'minutes', true);

        // currentTrip.approxDO = {
        //   time: approxDOCurrentTrip.toISOString(),
        //   difference: approxDOCurrentTripDiff,
        //   pointsDistance: doDistanceAndTime
        // };


        currentTrip.approxDO = approxDOCurrentTrip.toISOString();
        // currentTrip.minutesToPickup = approxDOCurrentTripDiff;
        currentTrip.minutesToPickup = doDistanceAndTime.duration;
        currentTrip.puMiles = doDistanceAndTime.distance;

      }
    }
  }

  async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.selectedMethod && this.selectedMethod === true) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2)) });
    }
    return resutl;
  }

  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assigTripsService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }

  onSelectedManifestTrip(item) {
    if (item.willProceed) return;
    item.isSelected = !item.isSelected;
  }

  getCorporateUserById() {
    return this.corporateService.getCorporateUserById(this.trip.cooperate)
      .pipe(takeUntil(componentDestroyed(this)))
  }

  getLevelOfService() {
    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypes() {
    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getServiceAreas() {
    return this.serviceArea.getServiceAreas({ status: 'active' });
  }

  toggleCapacity() {
    this.isCapacity = !this.isCapacity;
    this.filterCapacityBaseTrips();
  }

  filterCapacityBaseTrips() {
    if (this.isCapacity) {
      this.filteredDrivers = this.nearbyDrivers.filter(driver => {
        return driver.fleet && driver.fleet.hasOwnProperty("isCapacity") && driver.fleet.isCapacity ? true : false;
      });
    } else {
      this.filteredDrivers = null;
    }
  }


    getMiles(driverIndex, driver) {
      this.googleSelectedDriver = null;

      if (this.trip.jobOriginLatitude && this.trip.jobOriginLongitude && this.trip.jobDestinationLatitude && this.trip.jobDestinationLongitude) {
        const locationParams = {
          origin: this.trip.jobOriginLatitude + ' , ' + this.trip.jobOriginLongitude,
          destination: driver.coords[1] + ' , ' + driver.coords[0]
          // destination: vm.assign.jobDestinationLatitude + ' , ' + vm.assign.jobDestinationLongitude
        };
        locationParams['dbMiles'] = driver.miles || 0;
        locationParams['isLog'] = true;
        this.socketService.emit(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL, locationParams);
        // Socket.emit(‘assignTripManualFormETA’, locationParams);
        this.googleSelectedDriver = driver;
      } else {
        sweetAlert('Error', 'Please Select Pickup and DropOff Address', 'warning', 'OK');
      }
  }

  ngOnDestroy(): void {
  }

}
